import { createSelector } from 'reselect';
import { environmentSelector } from './commonSelectors';

export const loadedSelector = (state) => state.individualPortal.applications.loaded;
export const householdCaseIdSelector = (state) => state.individualPortal.applications.householdCaseId;
const applicationsSelector = (state) => state.individualPortal.applications.entities;

export const sortedApplicationsSelector = createSelector(
    applicationsSelector,
    environmentSelector,
    (applications) => {
        if (!applications || !applications.myApplications || applications.myApplications.length === 0) return false;

        const PAST_APP_STATUSES = ['CC', 'CL', 'DQ'];
        const currentApps = [];
        const pastApps = [];

        applications.myApplications && applications.myApplications.map(application => {
            if (PAST_APP_STATUSES.includes(application.applicationStatus)) {
                pastApps.push(application);
            } else {
                currentApps.push(application);
            }
        });

        return {
            currentApps,
            pastApps
        };
    }
);
